export function getMonday(offset = 0) {
  const base = new Date();
  const day = base.getDay();
  const monday = new Date(base);
  monday.setDate(base.getDate() - (day === 0 ? 6 : day - 1) + offset * 7);
  monday.setHours(0,0,0,0);
  return monday;
}

/** Weeks from this week's Monday to a Monday ISO date. Null when the date is not a Monday. */
export function weekOffsetForMondayISO(iso, now = new Date()) {
  const target = parseISODateLocal(iso);
  if (Number.isNaN(target.getTime()) || target.getDay() !== 1) return null;
  const base = new Date(now);
  const day = base.getDay();
  const currentMonday = new Date(base);
  currentMonday.setDate(base.getDate() - (day === 0 ? 6 : day - 1));
  currentMonday.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - currentMonday.getTime()) / (7 * 24 * 60 * 60 * 1000));
}

export function getScheduleBuilderInitialWeekOffset(goLiveISO) {
  const goLiveMonday = parseISODateLocal(goLiveISO);
  const base = new Date();
  const day = base.getDay();
  const currentMonday = new Date(base);
  currentMonday.setDate(base.getDate() - (day === 0 ? 6 : day - 1));
  currentMonday.setHours(0, 0, 0, 0);
  if (currentMonday < goLiveMonday) {
    const diffMs = goLiveMonday - currentMonday;
    return Math.round(diffMs / (7 * 24 * 60 * 60 * 1000));
  }
  return 0;
}

export function toLocalISO(d) {
  const yr = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${yr}-${mo}-${day}`;
}

export function parseISODateLocal(iso) {
  const [yr, mo, day] = String(iso || "").split("-").map(Number);
  return new Date(yr, mo - 1, day);
}

export function enumerateISODatesInclusive(fromISO, toISO) {
  const dates = [];
  const cur = parseISODateLocal(fromISO);
  const end = parseISODateLocal(toISO);
  while (cur <= end) {
    dates.push(toLocalISO(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return dates;
}

export function inclusiveISODayCount(fromISO, toISO) {
  const ms = parseISODateLocal(toISO) - parseISODateLocal(fromISO);
  return Math.floor(ms / (24 * 60 * 60 * 1000)) + 1;
}

export function maxAnnualLeaveEndISO(fromISO) {
  const cap = parseISODateLocal(fromISO);
  cap.setDate(cap.getDate() + 29);
  return toLocalISO(cap);
}

export function mondayISOForDate(iso) {
  const d = parseISODateLocal(iso);
  const dow = d.getDay();
  d.setDate(d.getDate() - (dow === 0 ? 6 : dow - 1));
  return toLocalISO(d);
}

export function nextMondayFrom(refDate) {
  const base = new Date(refDate);
  base.setHours(0, 0, 0, 0);
  const day = base.getDay();
  const monday = new Date(base);
  monday.setDate(base.getDate() - (day === 0 ? 6 : day - 1) + 7);
  return monday;
}

export function mondayInTwoWeeksFrom(refDate) {
  const base = new Date(refDate);
  base.setHours(0, 0, 0, 0);
  const day = base.getDay();
  const monday = new Date(base);
  monday.setDate(base.getDate() - (day === 0 ? 6 : day - 1) + 14);
  return monday;
}

/** Earliest annual-leave FROM date per Tuesday cutoff (Sun–Tue → next Mon; Wed–Sat → Mon +2w). */
export function getEarliestLeaveFromDate(refDate = new Date()) {
  const today = new Date(refDate);
  today.setHours(0, 0, 0, 0);
  const dayOfWeek = today.getDay();
  if (dayOfWeek <= 2) {
    return toLocalISO(nextMondayFrom(today));
  }
  return toLocalISO(mondayInTwoWeeksFrom(today));
}

export function leaveSubmissionWindow() {
  const today = new Date().getDay();
  const isOpen = today === 1 || today === 2;
  const nextMonday = getMonday(1);
  return {
    isOpen,
    nextMonday,
    requestWeekStart: toLocalISO(nextMonday),
  };
}

export function addDaysISO(iso, days) {
  const d = parseISODateLocal(iso);
  d.setDate(d.getDate() + days);
  return toLocalISO(d);
}

export function fmtDate(d) {
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

export function dayKey(d, dayIndex) {
  const names = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dn = names[d.getDay()];
  const dd = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  return `${dn} ${dd}`;
}

export const WDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const WDAYS_GR = ["Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ", "Κυρ"];
